import React, { useEffect, useState, useContext } from 'react';
import { saveToCache,loadFromCache, loadTitleCache } from './CacheHandler';
import { ModeContext } from './ModeContext';
import { Box, Typography, IconButton, Tooltip, Stack, Button, Badge } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import UploadFile from '@mui/icons-material/UploadFile';
import ForumIcon from '@mui/icons-material/Forum';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ChecklistIcon from '@mui/icons-material/Checklist';

import defaultDataset from '../dataset';
import { SendToCosmos ,LoadToCosmos} from './SendToCosmos';

const SidebarHeader = () => {
  const { mode, setMode, 
    sessionId, setSessionId, 
    messages, setMessages , 
    chatHistory,setChatHistory,
    isUploadMode, setIsUploadMode,
    activeButton, setActiveButton,
    loginInfo, setLoginInfo ,
    user,setUser ,
    dataset, setDataset,
    displayMode, setDisplayMode,
    unreadCommentCount } = useContext(ModeContext);

  const handleButtonClick = (type) => {
    setActiveButton(type);
  };
  // キャッシュから履歴を読み込む
  useEffect(() => {
    loadTitleCache('chat-history-cache').then((data) => {
      if (data) {
        const filteredData = data
          .map((chat) => {
            const firstUserMessage = chat.messages.find((msg) => msg.sender === 'user');
            return firstUserMessage
              ? {
                  id: chat.id,
                  title: chat.title,
                  messages: firstUserMessage.text,
                  mode: chat.mode,
                  timestamp: chat.timestamp || Date.now(), // タイムスタンプがない場合は現在時刻を使用
                }
              : null;
          })
          .filter((item) => item !== null);
        setChatHistory(filteredData);
      }
    });
  }, [sessionId]);



  useEffect(() => {
    //const data = JSON.parse(loginInfo.data);
    const data = loginInfo.data;

  // デフォルトでチャットアイコンを選択状態にする
  setActiveButton('chat');
  setIsUploadMode(false);

  console.log("data typeof", typeof data);
    //        const data = JSON.parse(loginInfo.data)
            let initialQuestion = {}
            if (data.init==='none'){
                //ベーシックデータ
                initialQuestion=defaultDataset.init
                console.log("defaultDataset typeof", typeof defaultDataset);
                setDataset(defaultDataset);
            }else{
                //カスタムデータ
                initialQuestion=data.init
                console.log("data typeof", typeof data);
                setDataset(data);
            };    
  }, []);


//test
const handleTest = async () => {
  const timestamp = Date.now();  
    try {
        const uppayload = {
          id: user,
          timestamp: Date.now(),
          container: "con-concierge-hist"
        };
        const item = await LoadToCosmos(uppayload);  // 非同期処理
        //const item = await SendToCosmos(uppayload);  // 非同期処理
        //item.item.messages.forEach((msg, index) => {

        if (!item) {
          for (const msg of item.item.messages) {

            await saveToCache(msg.id,'chat-history-cache',msg.title ,msg.messages,msg.timestamp,msg.mode,setChatHistory);
            // 他の処理もここで
          };
  
        }
      //}
    } catch (error) {
      console.error('handleTest error:', error);
    }

  };

  const handleNewChat = async () => {

    // 🔹 1. 初期データの取得
    let initialQuestion = {}
    let datasetToUse = {}
    
    if (dataset.init==='none'){
        //ベーシックデータ            
        initialQuestion=defaultDataset.init
        datasetToUse = defaultDataset
    }else{
        //カスタムデータ
        initialQuestion=dataset.init
        datasetToUse = dataset
    };

    // 初期メッセージのアイコンとモードは、最初のanswerが指すnextIdから取得
    let initialIcon = initialQuestion.icon;
    let initialMode = initialQuestion.mode;
    
    // 最初のanswerが存在し、nextIdが設定されている場合
    if (initialQuestion.answers && initialQuestion.answers.length > 0) {
        const firstAnswer = initialQuestion.answers[0];
        if (firstAnswer.nextId && datasetToUse[firstAnswer.nextId]) {
            const firstNextMessage = datasetToUse[firstAnswer.nextId];
            // アイコンの優先順位: firstAnswer.icon > firstNextMessage.icon > initialQuestion.icon
            initialIcon = firstAnswer.icon || firstNextMessage.icon || initialIcon;
            // モードは最初のnextIdのmodeを使用
            initialMode = firstNextMessage.mode || initialMode;
        } else if (firstAnswer.icon) {
            // nextIdがない場合でもanswerにiconがあれば使用
            initialIcon = firstAnswer.icon;
        }
    }
    
    // 🔹 2. モードの設定
    setMode(initialMode);
  
    // 🔹 3. メッセージのセット
    setMessages([
      {
        id: crypto.randomUUID(),
        sender: initialMode,
        text: initialQuestion.question,
        buttons: initialQuestion.answers.map((ans) => ({
          label: ans.content,
          nextId: ans.nextId,
          init:ans.init,
          icon: ans.icon, 
        })),
        mode: initialMode,
        icon: initialIcon
      },
    ]);
  
    // 🔹 4. Cosmos に保存
    const payload = await loadTitleCache('chat-history-cache');
    const uppayload = {
      id: user,
      timestamp: Date.now(),
      messages: payload,
      container: "con-concierge-hist"
    };
    console.log('uppayload', uppayload);
    await SendToCosmos(uppayload);
  
    // 🔹 5. Session ID を更新
    setSessionId(crypto.randomUUID());

    // 🔹 6. ChatDisplayを表示
    setDisplayMode('chat');
    setIsUploadMode(false);
    handleButtonClick("chat");
  };
  

  const [open, setOpen] = useState(false);

  const toggleDrawer = (state) => () => {
    setOpen(state);
  };

  return (
    <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: 1, p: 1 }}>
      {/* 新規ボタン（幅いっぱいの四角ボタン） */}

      <Button
        fullWidth
        variant="contained"
        color="primary"
        onClick={handleNewChat}
        startIcon={<OpenInNewIcon />}
        sx={{
          textAlign: "center",
          justifyContent: "center",
          fontSize: "13px",
          borderRadius: "8px",
          backgroundColor: "#b0c4de", // 薄いグレー
          color: "#4169e1",              // 文字色は黒に
          '&:hover': { backgroundColor: "#778899" }, // ホバー時も少し濃く
        }}
      >
        新規チャット
      </Button>

      {/* UploadFile と ForumIcon の横並び */}
      <Box sx={{ display: "flex", justifyContent: "flex-start", gap: 1, mt: 0.5 }}>


        <Tooltip title="取扱説明書_取込み" arrow>
        <IconButton
          onClick={() => {
            //handleTest();
            setDisplayMode('chat');
            setIsUploadMode(true);
            handleButtonClick("file");
          }}
          sx={{
            width: 30,
            height: 30,
            backgroundColor: activeButton === "file" ? "#b0c4de" : "inherit",
          }}
        >
          <UploadFile />
        </IconButton></Tooltip>

        {/* 依頼進捗一覧ボタン - HQまたはstoreユーザーのみ表示 */}
        {(loginInfo.authorityId === 'admin' || loginInfo.authorityId === 'HQ' || loginInfo.authorityId === 'store') && (
          <Tooltip title="依頼進捗一覧" arrow>
          <IconButton
            onClick={() => {
              setDisplayMode('request');
              setIsUploadMode(false);
              handleButtonClick("request");
            }}
            sx={{
              width: 30,
              height: 30,
              backgroundColor: activeButton === "request" ? "#b0c4de" : "inherit",
            }}
          >
            <Badge 
              badgeContent={unreadCommentCount}
              color="error"
              sx={{
                '& .MuiBadge-badge': {
                  fontSize: '0.6rem',
                  height: '16px',
                  minWidth: '16px',
                  padding: '0 4px'
                }
              }}
            >
              <ChecklistIcon />
            </Badge>
          </IconButton></Tooltip>
        )}


        <Tooltip title="チャット" arrow>
        <IconButton
          onClick={() => {
            setDisplayMode('chat');
            setIsUploadMode(false);
            handleButtonClick("chat");
          }}
          sx={{
            width: 30,
            height: 30,
            backgroundColor: activeButton === "chat" ? "#b0c4de" : "inherit",
          }}
        >
          <ForumIcon />
        </IconButton></Tooltip>
      </Box>
    </Box>
  );
};

export default SidebarHeader;
